import { create } from 'zustand'

import type { AlertRecord } from '../api/useAllAlerts'
import type { AlertTemplateConfig } from '../constants/alertTemplates'

export interface AlertStore {
  isManageAlertsOpen: boolean
  openManageAlerts: () => void
  closeManageAlerts: () => void
  isCreateAlertOpen: boolean
  openCreateAlert: () => void
  closeCreateAlert: () => void
  isCoreAlertOpen: boolean
  openCoreAlert: () => void
  closeCoreAlert: () => void
  selectedTemplate: AlertTemplateConfig | null
  setSelectedTemplate: (template: AlertTemplateConfig | null) => void
  editingAlert: AlertRecord | null
  openEditAlert: (alert: AlertRecord, template: AlertTemplateConfig) => void
  alertToDelete: AlertRecord | null
  isDeleteAlertOpen: boolean
  openDeleteAlert: (alert: AlertRecord) => void
  closeDeleteAlert: () => void
}

export const useAlertStore = create<AlertStore>((set) => ({
  isManageAlertsOpen: false,
  openManageAlerts: () => set({ isManageAlertsOpen: true }),
  closeManageAlerts: () => set({ isManageAlertsOpen: false }),
  isCreateAlertOpen: false,
  openCreateAlert: () => set({ isCreateAlertOpen: true }),
  closeCreateAlert: () => set({ isCreateAlertOpen: false, selectedTemplate: null }),
  isCoreAlertOpen: false,
  openCoreAlert: () => set({ isCoreAlertOpen: true }),
  closeCoreAlert: () => set({ isCoreAlertOpen: false, selectedTemplate: null, editingAlert: null }),
  selectedTemplate: null,
  setSelectedTemplate: (template) => set({ selectedTemplate: template }),
  editingAlert: null,
  openEditAlert: (alert, template) =>
    set({ isCoreAlertOpen: true, editingAlert: alert, selectedTemplate: template }),
  alertToDelete: null,
  isDeleteAlertOpen: false,
  openDeleteAlert: (alert) => set({ alertToDelete: alert, isDeleteAlertOpen: true }),
  closeDeleteAlert: () => set({ alertToDelete: null, isDeleteAlertOpen: false }),
}))
